import {
  Card,
  Grid,
  Pagination,
  Typography,
  CircularProgress,
  Stack,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import InfoIcon from "@mui/icons-material/Info";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PlaceIcon from "@mui/icons-material/Place";
import useAxiosAuth from "../../../hooks/useAxiosAuth";
import { useNavigate } from "react-router";
import config from "../../../config";
import React, { useEffect, useState } from "react";
import { Box } from "@mui/system";
import NoDataFound from "../../../components/NoDataFound";
import { convertDateToLocal } from "../../../utils/date-operations";

const Interviews = () => {
  const theme = useTheme();
  const axiosAuth = useAxiosAuth();
  const navigate = useNavigate();
  const pageSize = 50;
  const [interviewDetails, setInterviewDetails] = useState([]);
  const [loading, setLoading] = useState(true);

  const getInterviews = (skip) => {
    setLoading(true); // Set loading to true when fetching data
    axiosAuth
      .get(
        "/api/Interviewes/GetInterviews?status=0&skip=" +
          skip +
          "&take=" +
          pageSize
      )
      .then((response) => {
        setInterviewDetails(response.data);
        setLoading(false); // Set loading to false after data is received
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false); // Also set loading to false on error
      });
  };

  useEffect(() => {
    getInterviews(0);
  }, []);

  return (
    <>
      <Grid maxWidth="xl" sx={{ marginX: "auto", paddingY: 4, paddingX: 2 }}>
        <Card elevation={3}>
          <Grid
            sx={{
              background: "linear-gradient(to right,#4a7dcf 0%, #2a569f 100%)",
              paddingX: 2,
              paddingY: 1,
            }}
          >
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="h5" color="white.main">
                Interviews Details
              </Typography>
            </Grid>
          </Grid>

          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", marginY: 5 }}>
              <Stack
                direction="column"
                spacing={3}
                justifyContent="center"
                alignItems="center"
              >
                <Typography variant="h5" textAlign="center">
                  Loading Interview Details...
                </Typography>
                <CircularProgress />
              </Stack>
            </Box>
          ) : interviewDetails?.interviews &&
            interviewDetails.interviews.length > 0 ? (
            <>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  paddingX: 2,
                }}
              >
                <Pagination
                  count={Math.ceil(interviewDetails.count / pageSize)}
                  variant="outlined"
                  shape="rounded"
                  showFirstButton
                  showLastButton
                  color="primary"
                  sx={{ marginTop: 2 }}
                  onChange={(event, page) => {
                    getInterviews((page - 1) * pageSize);
                  }}
                />
              </Box>
              <Grid container spacing={2} sx={{ padding: 2 }}>
                {interviewDetails.interviews?.map((row, index) => (
                  <Grid key={row.id} item sm={6}>
                    <Card
                      variant="outlined"
                      onClick={() => {
                        navigate(
                          "/admin/jobpost?ref=" +
                            row?.jobPostId +
                            "&prePage=/admin/interviews"
                        );
                      }}
                      sx={{
                        minHeight: "130px",
                        padding: 2,
                        display: "flex",
                        direction: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: theme.palette.secondary.light,
                        cursor: "pointer",
                        "&:hover": {
                          boxShadow:
                            "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
                        },
                      }}
                    >
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Typography variant="h6" textAlign="left">
                            {row?.jobPost?.title}
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography variant="body1">
                            {row?.description}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          lg={3}
                          xl={3}
                          md={6}
                          sm={6}
                          xs={6}
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          <CalendarMonthIcon
                            color="primary"
                            fontSize="small"
                            sx={{
                              marginRight: 1,
                              color: theme.palette.secondary.dark,
                            }}
                          />
                          <Typography variant="body2">
                            {convertDateToLocal(row.dateTime)}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          lg={3}
                          xl={3}
                          md={6}
                          sm={6}
                          xs={6}
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          <PlaceIcon
                            color="primary"
                            fontSize="small"
                            sx={{
                              marginRight: 1,
                              color: theme.palette.secondary.dark,
                            }}
                          />
                          <Typography variant="body2">{row.venue}</Typography>
                        </Grid>
                      </Grid>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </>
          ) : (
            <Box sx={{ padding: 2 }}>
              <NoDataFound />
            </Box>
          )}
        </Card>
      </Grid>
    </>
  );
};

export default Interviews;
